export const CustomChart = ({ data = [], start, end, min, max }) => {
  const width = Math.round(100 / data.length);

  return (
    <div className="w-full h-[100px] flex items-end gap-[3px] px-[2px]">
      {data.map((item, i) => {
        // Create a more balanced height calculation
        const maxValue = Math.max(...data, 1);
        const normalizedValue = item / maxValue;
        
        // Use a more gradual height calculation for better visual balance
        const barHeight = Math.max(8, Math.min(80, normalizedValue * 60 + 10));
        
        const isInRange = min + i * ((max - min) / data.length) >= start && 
                         min + i * ((max - min) / data.length) <= end;
        
        return (
          <div
            key={i}
            style={{
              width: `${width}%`,
              height: `${barHeight}%`,
              minHeight: '8px',
              flex: '1 1 auto'
            }}
            className={`rounded-[4px] ${
              isInRange 
                ? 'bg-gradient-to-b from-[#5b1deec0] from-0% to-70% to-[#5b1dee]' 
                : 'bg-[#E3E3E3]'
            }`}
          ></div>
        );
      })}
    </div>
  );
};
